import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";
import { CrashType, Score } from "@keita/lanepatrol-sdk";
import { scoreCrashTypesIcons } from "../utils/score-utils";
import { getColor, lightenColor } from "../../survey/utils/score-utils";

interface Props {
  score?: Score;
}

export const ViewScoreSmall: React.FC<Props> = ({ score }) => {
  return (
    <Flex
      width="full"
      alignItems="center"
      justifyContent="center"
      gap={4}
      px={2}
      py={3}
    >
      <GlobalScore score={score} />

      <Stack gap={2} flexShrink={0}>
        {Object.values(CrashType).map((crashType) => {
          const entry = score?.[crashType];
          const color = getColor(entry?.riskFactor);
          const lightColor = lightenColor(color, 0.72);

          return (
            <Flex
              key={crashType}
              alignItems="center"
              justifyContent="flex-end"
              gap={2}
            >
              <Image
                src={scoreCrashTypesIcons[crashType]}
                boxSize="40px"
                objectFit="contain"
                flexShrink={0}
              />

              <Box
                flexShrink={0}
                bg={color}
                borderRadius="md"
                p="3px"
                borderWidth="1px"
                borderColor="blackAlpha.200"
                boxShadow="sm"
              >
                <Box
                  minW="56px"
                  textAlign="center"
                  bg={lightColor}
                  color="black"
                  borderRadius="sm"
                  px={2}
                  py={1}
                  fontSize="sm"
                  fontWeight="bold"
                  lineHeight="short"
                >
                  {entry ? entry.value.toFixed(2) : "–"}
                </Box>
              </Box>
            </Flex>
          );
        })}
      </Stack>
    </Flex>
  );
};

const GlobalScore = ({ score }: { score?: Score }) => {
  const entry = score?.global;
  const color = getColor(entry?.riskFactor);
  const lightColor = lightenColor(color, 0.72);

  return (
    <Stack
      width="105px"
      flexShrink={0}
      alignItems="center"
      justifyContent="center"
      gap={3}
    >
      <Text
        textAlign="center"
        fontSize="sm"
        fontWeight="semibold"
        lineHeight="short"
      >
        CycleRAP
        <br />
        Global Score:
      </Text>

      <Box
        bg={color}
        borderRadius="md"
        p="3px"
        borderWidth="1px"
        borderColor="blackAlpha.200"
        boxShadow="sm"
      >
        <Box
          minW="64px"
          textAlign="center"
          bg={lightColor}
          color="black"
          borderRadius="sm"
          px={2}
          py={1.5}
          fontSize="md"
          fontWeight="bold"
          lineHeight="short"
        >
          {entry ? entry.value.toFixed(2) : "–"}
        </Box>
      </Box>
    </Stack>
  );
};
